import React from 'react';
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars */
export const LanguageContext = React.createContext({ lang: 'ru', setLang: (lang: string) => {} });
